module.exports = __webpack_public_path__ + "img/person-running.a909600b.svg";